export default __webpack_public_path__ + "static/media/iraq.178ec6db.png";